export const NotImplemented = () => {
  return <div>Not implemented yet</div>
}
